export const messages = {
  en: {
    noticeDetail: {
      startTime: 'Start Time',
      endTime: 'End Time'
    }
  },
  zh: {
    noticeDetail: {
      startTime: '开始时间',
      endTime: '结束时间'
    }
  }
}